import { memo } from "react";
import Enkoping from "../../../assets/logos/Enkoping.svg";
import EnkopingFull from "../../../assets/logos/Enkoping_full.svg";
import Habo from "../../../assets/logos/Habo.svg";
import HaboFull from "../../../assets/logos/Habo_full.svg";
import Heby from "../../../assets/logos/Heby.png";
import HebyFull from "../../../assets/logos/Heby_full.png";
import Knivsta from "../../../assets/logos/Knivsta.svg";
import KnivstaFull from "../../../assets/logos/Knivsta_full.png";
import Osthammar from "../../../assets/logos/Osthammar.svg";
import OsthammarFull from "../../../assets/logos/Osthammar_full.svg";
import Tierp from "../../../assets/logos/Tierp.png";
import TierpFull from "../../../assets/logos/Tierp_full.png";
import Uppsala from "../../../assets/logos/Uppsala.svg";
import UppsalaFull from "../../../assets/logos/Uppsala_full.svg";

const logos = [
  {
    id: "Enkoping",
    alt: "Enköpings kommun",
    fullLogo: EnkopingFull,
    logo: Enkoping,
  },
  {
    id: "Habo",
    alt: "Håbo kommun",
    fullLogo: HaboFull,
    logo: Habo,
  },
  {
    id: "Heby",
    alt: "Heby kommun",
    fullLogo: HebyFull,
    logo: Heby,
  },
  {
    id: "Knivsta",
    alt: "Knivsta kommun",
    fullLogo: KnivstaFull,
    logo: Knivsta,
  },
  {
    id: "Osthammar",
    alt: "Östhammar kommun",
    fullLogo: OsthammarFull,
    logo: Osthammar,
  },
  {
    id: "Tierp",
    alt: "Tierp kommun",
    fullLogo: TierpFull,
    logo: Tierp,
  },
  {
    id: "Uppsala",
    alt: "Uppsala kommun",
    fullLogo: UppsalaFull,
    logo: Uppsala,
  },
];

type MunicipalityLogoProps = {
  id: string;
  customCssClass?: string;
} & ({ imgLink: string; fullLogo?: never } | { imgLink?: never; fullLogo?: boolean });

function MunicipalityLogo({ id, customCssClass, fullLogo = true, imgLink }: MunicipalityLogoProps) {
  if (imgLink) {
    return <embed src={imgLink} title={id} className={customCssClass} />;
  }

  if (!id) {
    return null;
  }

  const img = logos.find(logo => logo.id === id);

  if (!img) {
    return null;
  }

  const logo = fullLogo ? img.fullLogo : img.logo;

  return <embed src={logo} title={img.alt} className={customCssClass} />;
}

export default memo(MunicipalityLogo);
